import {
  FETCH_STUDENT_REQUEST,
  FETCH_STUDENT_SUCCESS,
  FETCH_STUDENT_FAILURE,
} from "../actions/studentActions";

const initialState = {
  loading: false,
  student: {},
  error: "",
  isLoaded: false,
};

const studentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STUDENT_REQUEST:
      return { ...state, loading: true };
    case FETCH_STUDENT_SUCCESS:
      return {
        loading: false,
        isLoaded: true,
        student: action.payload,
        error: "",
      };

    case FETCH_STUDENT_FAILURE:
      return {
        loading: false,
        isLoaded: false,
        student: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export default studentReducer;
